import React from 'react'
import styled from 'styled-components'
import { Draggable } from 'react-beautiful-dnd'
import './card.scss'

const Container = styled.div`
  border-radius: 2px;
  margin-bottom: 20px;
`

const CardSide = styled.div`
  display: flex;
  flex-direction: column;
`

export default class Card extends React.Component {
  constructor() {
    super()
    this.flipCard = this.flipCard.bind(this)

    this.state = { rotate: 0 }
  }

  flipCard() {
    this.props.cardFlip(this.props.card.id)

    document.body.classList.add('hide-flip-tooltip')
    localStorage.setItem('card-flip-tooltip', 'true')
  }

  render() {
    if (this.props.rotate && this.state.rotate === 0) {
      this.setState({ rotate: this.props.rotate })
    }

    if (this.props.rotate === 0 && this.state.rotate !== 0) {
      this.setState({ rotate: 0 })
    }

    return (
      <Draggable
        draggableId={this.props.card.id}
        index={this.props.index}
        isDragDisabled={
          this.props.isBeingDragged ||
          (this.props.cardIsBeingDragged && !this.props.isBeingDragged)
        }
      >
        {(provided, snapshot) => (
          <Container
            {...provided.draggableProps}
            ref={provided.innerRef}
            provider={provided}
            isDragging={snapshot.isDragging}
            {...provided.dragHandleProps}
          >
            <div
              onClick={this.flipCard}
              className={`flip-card ${this.props.flipped ? 'flipped' : ''} ${
                this.props.isBeingDragged ? 'dragging' : ''
              } ${this.props.compact} tooltip-top`}
              data-tooltip="There's more! Click this card to see the other side."
              style={{ transform: `rotate(${this.state.rotate}deg)` }}
            >
              <div className='flip-card-inner'>
                <CardSide className='flip-card-front'>
                  <hr className='topSeparator' />
                  <p
                    style={{
                      verticalAlign: 'middle',
                      marginTop: 0,
                      marginBottom: 0,
                      paddingTop: '2px',
                      fontSize: '1.5vw',
                    }}
                  >
                    {this.props.card.front}
                  </p>
                </CardSide>
                <CardSide className='flip-card-back'>
                  <hr className='topSeparator' />
                  <p
                    style={{
                      verticalAlign: 'middle',
                      marginTop: 0,
                      marginBottom: 0,
                      paddingTop: '2px',
                      fontSize: '1.5vw',
                    }}
                  >
                    {this.props.card.back}
                  </p>
                </CardSide>
              </div>
            </div>
          </Container>
        )}
      </Draggable>
    )
  }
}
